import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  attendanceAction,
  curriculumActions,
  deleteAttendance,
  examActions,
  guardianActions,
  linkGuardianToStudent,
  organizationActions,
  updateOperationalTime,
} from '../action';
import { showNotification } from '../slices/notification.slice';
import { syllabusActions } from '../action/syllabus.action';
import { organizationPreferenceActions } from '../action/organizationPreference.action';
import { editTeacherData, addTeacher } from '../slices/teacherSliceModel';
import { createStudentProfile, updateStudentProfile } from '../slices/studentSliceModel';
import authActions from '../action/auth.action';
import { createPost } from '../action/post.action';
import { organizationAdminActions } from '../action/organization-admin.action';
import {
  createClassroomAssign,
  deleteClassroomAssign,
  updateClassroomAssign,
} from '../action/teacher-assign-classroom.action';
import {
  createFeeTemplate,
  updateClassroomAssignedToFeeTemplate,
  updateFeeTemplate,
} from '../action/feeTemplate.action';
import academicYearActions from '../action/academicYear.action';

export const listenerMiddleware = createListenerMiddleware();

// Listen for successful "mutating" actions (create, update, delete)
listenerMiddleware.startListening({
  matcher: isAnyOf(
    guardianActions.createGuardian.fulfilled,
    guardianActions.removeGuardian.fulfilled,
    guardianActions.changePrimaryGuardian.fulfilled,
    createStudentProfile.fulfilled,
    updateStudentProfile.fulfilled,
    linkGuardianToStudent.fulfilled,
    editTeacherData.fulfilled,
    addTeacher.fulfilled,
    curriculumActions.createCurriculum.fulfilled,
    curriculumActions.updateCurriculum.fulfilled,
    organizationPreferenceActions.putOrganizationPreferences.fulfilled,
    syllabusActions.addSyllabus.fulfilled,
    syllabusActions.updateSyllabus.fulfilled,
    // CVA-4753: manualPayment is NOT listed here — AssignInvoicesTab's own
    // handleConfirmPayment already dispatches its own success toast (and
    // sequences closing the modal / reloading data / refreshing the active
    // session around it), so also matching it here fired the toast twice.
    examActions.createExam.fulfilled,
    examActions.updateExamAction.fulfilled,
    examActions.publishExam.fulfilled,
    examActions.releaseExam.fulfilled,
    examActions.cancelExam.fulfilled,
    // Paper builder save/clone (CVA-4153) — same generic success toast as every other mutation below.
    examActions.upsertExamPaperAction.fulfilled,
    examActions.cloneExamPaperAction.fulfilled,
    attendanceAction.postAttendance.fulfilled,
    attendanceAction.postAttendanceCheckout.fulfilled,
    deleteAttendance.fulfilled,
    organizationActions.updateMyOrganization.fulfilled,
    authActions.changePasswordFirstLogin.fulfilled,
    createPost.fulfilled,
    guardianActions.updateGuardian.fulfilled,
    guardianActions.deleteGuardian.fulfilled,
    updateOperationalTime.fulfilled,
    organizationAdminActions.createOrganizationAdmin.fulfilled,
    organizationAdminActions.updateOrganizationAdmin.fulfilled,
    organizationAdminActions.deleteOrganizationAdmin.fulfilled,
    organizationActions.updateOrganization.fulfilled,
    deleteClassroomAssign.fulfilled,
    createClassroomAssign.fulfilled,
    updateClassroomAssign.fulfilled,
    updateFeeTemplate.fulfilled,
    updateClassroomAssignedToFeeTemplate.fulfilled,
    createFeeTemplate.fulfilled,
    academicYearActions.createAcademicYear.fulfilled,
    academicYearActions.updateAcademicYear.fulfilled,
  ),

  effect: (action, listenerApi) => {
    if (
      action.payload &&
      typeof action.payload === 'object' &&
      action.payload !== null &&
      'message' in action.payload
    ) {
      listenerApi.dispatch(
        showNotification({
          message: (action.payload as { message: string }).message,
          severity: 'success',
        }),
      );
    }
  },
});
